import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from '@material-ui/core'
import { ExternalEntityGroupConsumer } from '../../../../../ExternalEntityGroupContext'
import { useStyles } from './Styles'

const ExternalEntitySelector = ({ selectedEntityType, selectedEntityReference, onEntityTypeChange, onEntityReferenceChange, formikErrors, formikTouched, onBlurReference }) => {
  const intl = useIntl()
  const classes = useStyles()

  return (
    <ExternalEntityGroupConsumer>
      {({ externalServiceHandlers }) => (
        <>
          {/* Entity Type Selection */}
          <div className={classes.BasicInfoRow}>
            <InputLabel id="Promocode.Rule2.EntityType">
              <FormattedMessage id='Fields.label.EntityType' />
            </InputLabel>
            <FormControl variant="outlined" margin="dense">
              <Select
                labelId="Promocode.Rule2.EntityType"
                id="Promocode.Rule2.EntityType"
                name="external_entity_type"
                value={selectedEntityType || ''}
                onChange={(e) => {
                  const value = e.target.value
                  onEntityTypeChange(value)
                }}
                displayEmpty
                margin="dense"
              >
                <MenuItem value="">
                  <FormattedMessage id='Fields.option.None' />
                </MenuItem>
                {externalServiceHandlers.map((handler) => (
                  <MenuItem key={handler.key} value={handler.key}>
                    {handler.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          {/* Entity Reference */}
          <div className={classes.BasicInfoRow}>
            <InputLabel id="Promocode.Rule2.EntityReference">
              <FormattedMessage id='Fields.label.EntityReference' />
            </InputLabel>
            <FormControl variant="outlined">
              <TextField
                placeholder={intl.formatMessage({ id: 'Fields.input.PromocodeRuleExternalEntityReference.placeholder' })}
                id="Promocode.Rule2.EntityReference"
                type={'text'}
                margin="dense"
                variant="outlined"
                name="external_entity_reference"
                value={selectedEntityReference || ''}
                onChange={(e) => onEntityReferenceChange(e.target.value)}
                onBlur={onBlurReference}
                disabled={!selectedEntityType}
                helperText={formikErrors && formikTouched && formikErrors}
                error={!!(formikErrors && formikTouched)}
              />
            </FormControl>
          </div>
        </>
      )}
    </ExternalEntityGroupConsumer>
  )
}

export default ExternalEntitySelector

